import { Injectable } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private nzNotification: NzNotificationService) { }

  /**
   * Muestra una notificación de éxito
   * @param title Título de la notificación (opcional)
   * @param description Descripción de la notificación (opcional)
   */
  success(title: string = 'Operación exitosa', description: string = 'La operación se completó correctamente'): void {
    this.createNotification('success', 'check-circle', title, description, 4000);
  }

  /**
   * Muestra una notificación de advertencia
   * @param title Título de la notificación (opcional)
   * @param description Descripción de la notificación (opcional)
   */
  warning(title: string = 'Advertencia', description: string = 'Revise la información antes de continuar'): void {
    this.createNotification('warning', 'alert-triangle', title, description, 5000);
  }

  /**
   * Muestra una notificación informativa
   * @param title Título de la notificación (opcional)
   * @param description Descripción de la notificación (opcional)
   */
  info(title: string = 'Información', description: string = 'Información importante para el usuario'): void {
    this.createNotification('info', 'info', title, description, 4000);
  }

  /**
   * Muestra una notificación de error
   * @param title Título de la notificación (opcional)
   * @param description Descripción de la notificación (opcional)
   */
  error(title: string = 'Error', description: string = 'Ha ocurrido un error inesperado'): void {
    this.createNotification('error', 'x-circle', title, description, 6000);
  }

  /**
   * Crea una notificación con template HTML personalizado usando app-icon
   * @param type Tipo de notificación
   * @param iconName Nombre del icono de Lucide
   * @param title Título de la notificación
   * @param description Descripción de la notificación
   * @param duration Duración en milisegundos
   */
  private createNotification(
    type: 'success' | 'warning' | 'info' | 'error',
    iconName: string,
    title: string,
    description: string,
    duration: number
  ): void {
    // Definir colores para cada tipo de notificación
    const iconColors = {
      success: '#10b981', // Verde
      warning: '#f59e0b', // Amarillo
      info: '#3b82f6',    // Azul
      error: '#ef4444'    // Rojo
    };

    const template = `
      <div class="custom-notification">
        <div class="notification-icon-${type}"></div>
        <div class="text-container">
          <div class="title">${title}</div>
          <div class="description">${description}</div>
        </div>
      </div>
    `;

    this.nzNotification.create(
      type,
      '',
      template,
      {
        nzDuration: duration,
        nzPlacement: 'bottomRight',
        nzClass: 'request-notification'
      }
    );
  }
}
